<template lang="pug">
  gb-card.member-list
    .list-row
      p.list-item.header 施設名
      p.list-item.header 住所
      p.list-item.header 保育日誌
      p.list-item.header
      p.list-item.header
    .hr-secondary
    .list-row(
      v-for="(member, index) in memberList"
      :style="index % 2 === 0 ? 'background-color: #dfdfdf' : ''"
    )
      p.list-item {{ member.nursery_name }}
      p.list-item {{ member.address }}
      .list-item(style="text-align: center")
        input(
          @change="changeIsDiary(member)"
          type="checkbox"
          :id="member.server_id + '#' + member.nursery_code"
          v-model="member.isDiaryEnabled"
        )
      .list-item
        gb-button.text-edit(
          @clicked="clickNurse(member)"
        ) 保育士一覧
      .list-item
        gb-button.text-edit(
          @clicked="clickChild(member)"
        ) 園児一覧
</template>

<script>
import GbCard from '@/components/atoms/GbCard.vue'
import GbButton from '@/components/atoms/GbButton.vue'

export default {
  name: 'MemberListSchool',
  components: {
    GbCard,
    GbButton
  },
  props: {
    memberList: {
      type: Array,
      default: () => { return [] }
    }
  },
  methods: {
    clickNurse ($e) {
      this.$emit('clickNurse', $e)
    },
    clickChild ($e) {
      this.$emit('clickChild', $e)
    },
    changeIsDiary (member) {
      console.log('changeIsDiary', member)
      this.$emit('changeIsDiary', member)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../../stylus/main.styl'
.member-list
  width 100%
  padding-left 0 !important
  padding-right 0 !important
.list-row
  padding 0 10px
  display flex
  flex-direction row
  align-items center
  p
    font-size 12px
.list-item
  flex 1
  color $color-secondary !important
  &.header
    font-weight 400
.text-danger
  margin 0 !important
</style>



// WEBPACK FOOTER //
// src/components/organisms/MemberListSchool.vue